import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import { ExpertFilesModule } from '@techspert-io/expert-files';
import { ExpertsModule } from '@techspert-io/experts';
import { NgxFileDropModule } from 'ngx-file-drop';
import { BtxSharedModule } from '../../../../shared/btx-shared.module';
import { MaterialModule } from '../../../../shared/patterns/material-module';
import { SearchModule } from '../../../search/search.module';
import { ExpertCloneDirective } from './expert-clone/expert-clone.directive';
import { ExpertPreviousBioButtonComponent } from './expert-profile-dialog/expert-previous-bio-button/expert-previous-bio-button.component';
import { ExpertProfileAvailabilityComponent } from './expert-profile-dialog/expert-profile-availability/expert-profile-availability.component';
import { ExpertProfileBillingComponent } from './expert-profile-dialog/expert-profile-billing/expert-profile-billing.component';
import { ExpertProfileBiographyComponent } from './expert-profile-dialog/expert-profile-biography/expert-profile-biography.component';
import { ExpertProfileDetailsComponent } from './expert-profile-dialog/expert-profile-details/expert-profile-details.component';
import { ExpertProfileDialogComponent } from './expert-profile-dialog/expert-profile-dialog.component';
import { ExpertProfilePreviousExpertsComponent } from './expert-profile-dialog/expert-profile-previous-experts/expert-profile-previous-experts.component';
import { ExpertProfileScreenerComponent } from './expert-profile-dialog/expert-profile-screener/expert-profile-screener.component';
import { ExpertScreenerResultDialogComponent } from './expert-screener-results-dialog/expert-screener-result-dialog.component';
import { OpportunityActionsMenuComponent } from './opportunity-actions-menu/opportunity-actions-menu.component';
import { AvailabilityBoxComponent } from './opportunity-expert-list/expert/availability-box/availability-box.component';
import { CountryBoxComponent } from './opportunity-expert-list/expert/country-box/country-box.component';
import { EmailBoxComponent } from './opportunity-expert-list/expert/email-box/email-box.component';
import { ExpertComponent } from './opportunity-expert-list/expert/expert.component';
import { ScheduledBoxReminderComponent } from './opportunity-expert-list/expert/scheduled-box/scheduled-box-reminder/scheduled-box-reminder.component';
import { ScheduledBoxComponent } from './opportunity-expert-list/expert/scheduled-box/scheduled-box.component';
import { ScreenerBoxComponent } from './opportunity-expert-list/expert/screener-box/screener-box.component';
import { OpportunityExpertListComponent } from './opportunity-expert-list/opportunity-expert-list.component';
import { OpportunityResultsComponent } from './opportunity-results.component';
import { OpportunitySearchSelectDialogComponent } from './opportunity-search-select-dialog/opportunity-search-select-dialog.component';
import { OpportunityTopBarComponent } from './opportunity-top-bar/opportunity-top-bar.component';
import { ExpertRespondedDetailComponent } from './responded-dialog/expert-responded-detail/expert-responded-detail.component';
import { RespondedDialogComponent } from './responded-dialog/responded-dialog.component';
import { SearchDialogComponent } from './search-dialog/search-dialog.component';
import { SolicitationModule } from './send-solicitation-dialog/solicitation.module';

@NgModule({
  declarations: [
    OpportunityResultsComponent,
    OpportunityTopBarComponent,
    OpportunityExpertListComponent,
    ExpertComponent,
    EmailBoxComponent,
    CountryBoxComponent,
    AvailabilityBoxComponent,
    ScheduledBoxComponent,
    ScheduledBoxReminderComponent,
    ExpertProfileDialogComponent,
    RespondedDialogComponent,
    ExpertRespondedDetailComponent,
    ExpertProfileAvailabilityComponent,
    ExpertProfileDetailsComponent,
    ExpertProfileBillingComponent,
    ExpertProfileBiographyComponent,
    ExpertProfileScreenerComponent,
    ExpertProfilePreviousExpertsComponent,
    SearchDialogComponent,
    ExpertCloneDirective,
    OpportunityActionsMenuComponent,
    ScreenerBoxComponent,
    ExpertScreenerResultDialogComponent,
    ExpertPreviousBioButtonComponent,
    OpportunitySearchSelectDialogComponent,
  ],
  imports: [
    BtxSharedModule,
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    SolicitationModule,
    MatTreeModule,
    MatInputModule,
    SearchModule,
    MaterialModule,
    NgxFileDropModule,
    ExpertsModule,
    ExpertFilesModule,
  ],
  exports: [
    OpportunityResultsComponent,
    OpportunityTopBarComponent,
    OpportunityExpertListComponent,
    ExpertComponent,
    EmailBoxComponent,
    CountryBoxComponent,
    ScheduledBoxComponent,
    ScheduledBoxReminderComponent,
    AvailabilityBoxComponent,
    ExpertProfileDialogComponent,
    ExpertProfileAvailabilityComponent,
    ExpertProfileDetailsComponent,
    ExpertProfileBillingComponent,
    ExpertProfileBiographyComponent,
    ExpertProfileBiographyComponent,
    SearchDialogComponent,
  ],
})
export class OpportunityModule {}
